module.exports = __webpack_public_path__ + "media/images/samples/300x300/10-4a826180bba0a2a6bd8827b71ef67caa.jpg";